import { immerable } from "immer";
import { IMultiSelectFilterItem } from "components/filters/MultiSelectFilter";

export class PlaceSuperCategory implements IMultiSelectFilterItem {
    [immerable] = true;

    private _isSelected: boolean;
    public readonly id: string;
    public readonly name: string;
    public readonly placeCategoryIds: number[];
    constructor(
        name: string,
        placeCategoryIds: number[],
        isSelected: boolean
    ) {
        this.id = name;
        this.name = name;
        this.placeCategoryIds = placeCategoryIds;
        this._isSelected = isSelected;
    }

    isSelected() {
        return this._isSelected;
    }

    setIsSelected(isSelected: boolean) {
        this._isSelected = isSelected;
    }

    toggleIsSelected() {
        this._isSelected = !this._isSelected;
    }
}
